<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <!-- v-if="!sonChildStatus" -->
      <template v-if="!sonChildStatus">
        <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
          <span v-if="item.redirect==='noRedirect'||index==levelList.length-1" class="no-redirect">
            {{ generateTitle(item.meta.title) }}
          </span>
          <!-- 只有首页的breadcrumb -->
          <a v-else @click.prevent="handleLink(item)">{{ generateTitle(item.meta.title) }}</a>

        </el-breadcrumb-item>
      </template>
      <template v-else>
        <el-breadcrumb-item :to="{ path: '/' }" key="1">首頁</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/waybill' }" key="2">運單管理</el-breadcrumb-item>
        <el-breadcrumb-item v-if="ModifyStatus" :to="{ path: '/batchImport' }" key="3">批量導入</el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
          <a v-if="index==levelList.length-1" class="no-redirect">{{ generateTitle(item.meta.title)}}</a>
        </el-breadcrumb-item>
      </template>

    </transition-group>
  </el-breadcrumb>
</template>

<script>
import { generateTitle } from '@/utils/i18n'
import pathToRegexp from 'path-to-regexp'

export default {
  data() {
    return {
      levelList: null,
      sonChildStatus:false,
      ModifyStatus:false,

    }
  },
  watch: {
    $route(route) {
      // console.log('route',route)

      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith('/redirect/')) {
        return
      }
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    generateTitle,
    // 获取面包屑
    getBreadcrumb() {
      // only show routes with meta.title
      // 仅显示路线元标题
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      console.log('面包屑导航: ', matched);
      const first = matched[0]
      console.log('first: ', first);
      if (!this.isHome(first)) {
        matched = [{ path: '/home', meta: { title: 'home' }}].concat(matched)
      }



      if(first.name=='AddWaybill' || first.name=='EditWaybill' ||  first.name=='WaybillPrinting' || first.name=='BatchImport'){
        this.sonChildStatus = true
        console.log('新建运单')
        // $(".el-breadcrumb__item").hide()
        this.ModifyStatus = false
        this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
        this.levelList.shift()
        console.log('this.levelList--2: ', this.levelList);
      }else if(first.name=='ModifyWaybill'){
        console.log('修改運單')
        this.sonChildStatus = true
        this.ModifyStatus = true
        this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
        this.levelList.shift()
      }else{
        this.ModifyStatus = false
        this.sonChildStatus = false
        this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
      }
      console.log(' 面包屑信息: ',  this.levelList);
    },
    // 是否为首页
    isHome(route) {
      const name = route && route.name
      console.log('name-1: ', name);
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'Home'.toLocaleLowerCase()
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(item) {
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      this.$router.push(this.pathCompile(path))
    }
  }
}
</script>

<style scoped>
.el-breadcrumb__item:hover{
  cursor: pointer !important;
}
</style>
<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 80px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}

</style>
